// extracted by mini-css-extract-plugin
module.exports = {"botaoPrint":"BotaoImpressao_botaoPrint__2ScFs"};